// extracted by mini-css-extract-plugin
module.exports = {"root":"_2H7FQ","textSeparator":"_2jK2A","textSeparatorLine":"_1QqJO","textSeparatorContent":"ycr_T"};